import { Table } from '@ui/uikit/components/common/Table';

import type {
  IsSqrvVotingPowerUsed,
  IsValidationFinished,
} from '../../../ApplicationValidationSummary';
import styles from './ApplicationValidationVotesTable.module.scss';
import type { ApplicationTableData } from './getApplicationValidationVotesTableColumns';
import { getApplicationValidationVotesTableColumns } from './getApplicationValidationVotesTableColumns';

const gridTemplateColumns = '1fr 116px';
const sqrvGridTemplateColumns = '1fr 116px 116px';

export interface ApplicationValidationVotesTableProps
  extends IsValidationFinished,
    IsSqrvVotingPowerUsed {
  selfData: ApplicationTableData[];
  data: ApplicationTableData[];
  isLoading: boolean;
}

export const ApplicationValidationVotesTable = ({
  selfData,
  data,
  isLoading = false,
  isValidationFinished,
  isSqrvVotingPowerUsed,
}: ApplicationValidationVotesTableProps) => {
  const showVotingPowerColumn = isSqrvVotingPowerUsed && isValidationFinished;
  const showSelfTable = selfData.length !== 0;

  const baseProps = {
    gridTemplateColumns: showVotingPowerColumn ? sqrvGridTemplateColumns : gridTemplateColumns,
    isLoading,
    disableMobileLayout: !showVotingPowerColumn,
  };

  const { columns, selfColumns } = getApplicationValidationVotesTableColumns({
    isSqrvVotingPowerUsed,
    isValidationFinished,
  });

  return (
    <div className={styles.container}>
      {showSelfTable && <Table {...baseProps} columns={selfColumns} data={selfData} />}
      <Table {...baseProps} columns={columns} data={data} />
    </div>
  );
};
